"use strict";

var _defineProperty = require("/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/helpers/defineProperty.js");

var _objectWithoutProperties = require("/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _createClass = require("/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/helpers/createClass.js");

var _classCallCheck = require("/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _inherits = require("/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

var _excluded = ["transformers", "fieldMappings", "apiUrl", "leadType"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LeadspediaApi = void 0;

var LeadspediaApiBase_1 = require("../lib/LeadspediaApiBase");

var ClientActions_1 = require("./ClientActions");

var LeadspediaApi = /*#__PURE__*/function (_LeadspediaApiBase_1$) {
  _inherits(LeadspediaApi, _LeadspediaApiBase_1$);

  var _super = _createSuper(LeadspediaApi);

  function LeadspediaApi() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        transformers = _ref.transformers,
        fieldMappings = _ref.fieldMappings,
        _ref$apiUrl = _ref.apiUrl,
        apiUrl = _ref$apiUrl === void 0 ? "https://api.carloanscanada.com" : _ref$apiUrl,
        _ref$leadType = _ref.leadType,
        leadType = _ref$leadType === void 0 ? "credit" : _ref$leadType,
        options = _objectWithoutProperties(_ref, _excluded);

    _classCallCheck(this, LeadspediaApi);

    return _super.call(this, _objectSpread(_objectSpread({}, options), {}, {
      client: new ClientActions_1.ClientActions(apiUrl, leadType, {
        transformers: transformers,
        fieldMappings: fieldMappings,
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        }
      })
    }));
  }

  return _createClass(LeadspediaApi);
}(LeadspediaApiBase_1.LeadspediaApiBase);

exports.LeadspediaApi = LeadspediaApi;